import { faker } from '@faker-js/faker';
import type { Attachment } from '../attachment';
import { AttachmentType } from '../attachment-type';

export class AttachmentMock {
  static one(properties?: Partial<Attachment>): Attachment {
    return {
      id: faker.datatype.uuid(),
      type: AttachmentType.Document,
      title: faker.random.word(),
      description: faker.random.words(5),
      filename: `${faker.random.word()}.png`,
      ...properties,
    };
  }

  static many(count = 2): Attachment[] {
    const attachments: Attachment[] = [];
    for (let i = 0; i < count; i++) {
      attachments.push(this.one());
    }
    return attachments;
  }
}
